module.exports = __webpack_public_path__ + "img/lg_ring_0_0_1_0.888ed417.png";